<template>
  <div v-if="cte">
    <div class="box">
      <div class="columns">
        <div class="column is-4 sc-pre-invoice-detail-ctes__width">
          <article class="panel">
            <p class="panel-heading has-text-primary has-text-weight-bold">
              Dados fiscais
            </p>
            <sc-grid-layout :columns="1">
              <sc-grid-item :class="{ 'sc-cte-global': cte.invoice_list.length > 1 }">
                <b>Número do Pedido:</b>
                <div v-for="so in cte.invoice_list">
                  <p class="sc-pre-invoice-detail-ctes__grid-item">
                    <a :href="`/ng#/order-number/${so.order_number}`">
                      {{ so.order_number }}
                    </a>
                  </p>
                </div>
              </sc-grid-item>

              <sc-grid-item :class="{ 'sc-cte-global': cte.invoice_list.length > 1 }">
                <b>Código de rastreio:</b>
                <div v-for="so in cte.invoice_list">
                  <p class="sc-pre-invoice-detail-ctes__grid-item">
                    <a :href="`http://status-testing.intelipost.com.br/tracking/${so.tracking_code}`"
                        target="_blank">
                      {{ so.tracking_code }}
                    </a>
                  </p>
                </div>
              </sc-grid-item>

              <sc-grid-item :class="{ 'sc-cte-global': cte.invoice_list.length > 1 }">
                <b>{{ getInvoiceLabel(cte.invoice_list[0].invoice) }}</b>
                <div v-for="so in cte.invoice_list">
                  <p
                    class="sc-pre-invoice-detail-ctes__grid-item">
                    {{ getInvoiceIdentifier(so.invoice) }}
                  </p>
                </div>
              </sc-grid-item>

              <sc-grid-item>
                <b>Valor dos produtos:</b>
                <p class="sc-pre-invoice-detail-ctes__grid-item">
                  {{ getSumOfInvoiceCost(cte.invoice_list, 'products_value') | currency }}
                </p>
              </sc-grid-item>

              <sc-grid-item class="sc-pre-invoice-detail-ctes__border-radius">
                <b>Valor da {{ getInvoiceLabel(cte.invoice_list[0].invoice) }}:</b>
                <p class="sc-pre-invoice-detail-ctes__grid-item">
                  {{ getSumOfInvoiceCost(cte.invoice_list, 'total_value') | currency }}
                </p>
              </sc-grid-item>
            </sc-grid-layout>
          </article>
        </div>
      </div>
    </div>

    <div class="box">
      <div class="sc-pre-invoice-detail-ctes">
        <div
          v-for="cte in cte.cte_list"
          :key="cte.cte_type.value">
          <article class="panel sc-pre-invoice-detail-ctes__article">
            <p class="panel-heading has-text-primary sc-pre-invoice-detail-ctes__heading">
              <template v-if="cte.cte_type && cte.cte_type.label">
                {{ cte.cte_type.label }}
              </template>
              <template v-else>
                Não informado
              </template>
            </p>

            <sc-grid-layout :columns="2">
              <sc-grid-item>
                <b>Número do Cte:</b>
                <p class="sc-pre-invoice-detail-ctes__grid-item">
                  {{ cte.infos_cte.number }}
                </p>
              </sc-grid-item>

              <sc-grid-item>
                <b>Série:</b>
                <p class="sc-pre-invoice-detail-ctes__grid-item">
                  {{ cte.infos_cte.serie }}
                </p>
              </sc-grid-item>

              <sc-grid-item>
                <b>Chave:</b>
                <p class="sc-pre-invoice-detail-ctes__grid-item">
                 {{ cte.infos_cte.key }}
                </p>
              </sc-grid-item>

              <sc-grid-item>
                <b>Protocolo:</b>
                <p class="sc-pre-invoice-detail-ctes__grid-item">
                  {{ cte.infos_cte.protocol_number }}
                </p>
              </sc-grid-item>

              <sc-grid-item>
                <b>Data da Emissão:</b>
                <p class="sc-pre-invoice-detail-ctes__grid-item">
                  {{ cte.infos_cte.issue_date | date("DD/MM/YYYY") }}
                </p>
              </sc-grid-item>

              <sc-grid-item>
                <b>Data de Validação na Sefaz:</b>
                <p class="sc-pre-invoice-detail-ctes__grid-item">
                  {{ cte.infos_cte.sefaz_validation_date | date("DD/MM/YYYY") }}
                </p>
              </sc-grid-item>

              <sc-grid-item>
                <b>Cód. Status na Sefaz:</b>
                <p class="sc-pre-invoice-detail-ctes__grid-item">
                  {{ cte.infos_cte.status_sefaz_code }}
                </p>
              </sc-grid-item>

              <sc-grid-item>
                <b>Status na Sefaz:</b>
                <p class="sc-pre-invoice-detail-ctes__grid-item"
                  :class="getClassByStatusSefaz(cte.infos_cte)">
                  <template v-if="cte.infos_cte.status_sefaz && cte.infos_cte.status_sefaz.label">
                    {{ cte.infos_cte.status_sefaz.label }}
                  </template>
                  <template v-else>
                    Não informado
                  </template>
                </p>
              </sc-grid-item>

              <sc-grid-item>
                <b>Origem do arquivo:</b>
                <p class="sc-pre-invoice-detail-ctes__grid-item">
                  {{ cte.infos_cte.file_origin }}
                </p>
              </sc-grid-item>

              <sc-grid-item>
                <b>Nome do arquivo:</b>
                <p class="sc-pre-invoice-detail-ctes__grid-item">
                  {{ cte.infos_cte.file_name }}
                </p>
              </sc-grid-item>

              <sc-grid-item>
                <b>Situação:</b>
                <p class="sc-pre-invoice-detail-ctes__grid-item">
                  <template v-if="cte.infos_cte.status_cte && cte.infos_cte.status_cte.label">
                    {{ cte.infos_cte.status_cte.label }}
                  </template>
                  <template v-else>
                    Não informado
                  </template>
                </p>
              </sc-grid-item>

              <sc-grid-item>
                <b>Data da Validação:</b>
                <p class="sc-pre-invoice-detail-ctes__grid-item">
                  {{ cte.infos_cte.validation_date | date("DD/MM/YYYY") }}
                </p>
              </sc-grid-item>
            </sc-grid-layout>
         </article>
        </div>
      </div>

      <div class="sc-form__footer page-pre-invoice-detail__box-footer">
        <div class="column has-text-right">
          <sc-button @click="$emit('back')"> Voltar </sc-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ScCard, ScButton } from '@intelipost-js/secure-components';
import { createNamespacedHelpers } from 'vuex';
import ScGridLayout from './components/ScGridLayout';
import ScGridItem from './components/ScGridItem';
import { getInvoiceIdentifier, getInvoiceLabel } from '../../helpers/invoiceValuesHelper';

const {
  mapState,
  mapActions,
} = createNamespacedHelpers('recon/preInvoiceDetail/preInvoiceDetailCtes');

export default {
  name: 'sc-pre-invoice-detail-ctes',
  methods: {
    ...mapActions(['getCtesList']),
    getInvoiceIdentifier,
    getInvoiceLabel,
    getClassByStatusSefaz(cte) {
      const { status_sefaz } = cte || {};
      const { value } = status_sefaz || {};

      const possibleStatus = {
        VALIDATED: 'success',
        DENIED: 'warning',
        REJECTED: 'danger',
      };

      return possibleStatus[value]
        ? `sc-pre-invoice-detail-ctes__text--${possibleStatus[value]}`
        : false;
    },
    getSumOfInvoiceCost(invoice_list, cost_property) {
      if (invoice_list.length === 1) {
        return invoice_list[0][cost_property];
      }
      return invoice_list
          .map(invoice => invoice[cost_property])
          .reduce((acc, value) => acc + value, 0);
    },
  },
  computed: {
    ...mapState(['loading', 'cte']),
  },
  beforeMount() {
    const { id } = this.$route.params || {};
    const { action } = this.$route.query || {};

    this.getCtesList({ id, action });
  },
  components: {
    ScButton,
    ScCard,
    ScGridLayout,
    ScGridItem,
  },
};
</script>

<style lang="scss" scoped>
.sc-pre-invoice-detail-ctes {
  &__width{
    width: auto;
  }

  &__article {
    width: 100%;
    margin-bottom: 1.25rem;
  }

  &__border-radius {
    border-bottom-left-radius: 4px;
  }

  &__grid-item {
    min-width: 0;
    min-height: 0;
    padding-left: 25px;
    word-wrap: break-word;
    word-break: break-all;
    max-width: 100%;
    text-align: right;

    @media (max-width: 600px) {
      text-align: left;
      padding: 0;
    }
  }

  &__heading {
    border-bottom: none;
    font-weight: bold;
  }

  &__text {
    &--danger {
      font-weight: bold;
      color: #e84c3d;
    }
    &--warning {
      font-weight: bold;
      color: #bca316;
    }
    &--success {
      font-weight: bold;
      color: #48c774;
    }
  }
}

.sc-cte-global {
  flex-direction: column;
}
</style>



// WEBPACK FOOTER //
// node_modules/@intelipost-modules/secure-recon/features/pre-invoice-detail/components/sc-pre-invoice-detail-ctes/ScPreInvoiceDetailCtes.vue?5b82b9a5